import type { CSSWidth } from 'types';

import { LoadingSkeletonItem } from './LoadingSkeleton';

interface Props {
	className?: string;
	width?: CSSWidth;
}

export default function LoadingFormFieldSkeletonItem({
	className,
	width = '100%',
}: Props) {
	return (
		<LoadingSkeletonItem height="3.5rem" width={width} className={className} />
	);
}
LoadingFormFieldSkeletonItem.displayName = 'LoadingFormFieldSkeletonItem';
